import { BonusSettlementSupplierStatus } from '@synergy/models';
import { createReducer } from '@reduxjs/toolkit';

import { BonusSettlementSupplierDetail } from '../models/bonus-settlement-supplier-detail';
import {
    addCustomer,
    getBonusSettlementsSupplierDetail,
    removeCustomer,
    resetBonusSettlementsSupplierDetail,
    submitBonusSettlementSupplierDetail,
    updateSupplierBonusSettlementFiles,
} from './bonus-settlements-supplier-detail-actions';

export interface BonusSettlementsSupplierDetailReducerState {
    bonusSettlementSupplierDetail: BonusSettlementSupplierDetail | null;
    requesting: boolean;
    isSubmitting: boolean;
}

export const initialBonusSettlementsSupplierDetailReducerState: BonusSettlementsSupplierDetailReducerState = {
    bonusSettlementSupplierDetail: null,
    requesting: false,
    isSubmitting: false,
};

export const bonusSettlementsSupplierDetailReducer = createReducer(
    initialBonusSettlementsSupplierDetailReducerState,
    builder =>
        builder
            .addCase(getBonusSettlementsSupplierDetail.pending, state => {
                state.requesting = true;
            })
            .addCase(getBonusSettlementsSupplierDetail.fulfilled, (state, action) => {
                state.bonusSettlementSupplierDetail = action.payload;
                state.requesting = false;
            })
            .addCase(getBonusSettlementsSupplierDetail.rejected, state => {
                state.requesting = false;
            })
            .addCase(submitBonusSettlementSupplierDetail.pending, state => {
                state.isSubmitting = true;
            })
            .addCase(submitBonusSettlementSupplierDetail.fulfilled, state => {
                state.isSubmitting = false;

                if (!state.bonusSettlementSupplierDetail) {
                    return;
                }

                state.bonusSettlementSupplierDetail.status = BonusSettlementSupplierStatus.Sent;
            })
            .addCase(submitBonusSettlementSupplierDetail.rejected, state => {
                state.isSubmitting = false;
            })
            .addCase(resetBonusSettlementsSupplierDetail, state => {
                state.bonusSettlementSupplierDetail =
                    initialBonusSettlementsSupplierDetailReducerState.bonusSettlementSupplierDetail;
            })
            .addCase(addCustomer.fulfilled, (state, action) => {
                if (state.bonusSettlementSupplierDetail) {
                    state.bonusSettlementSupplierDetail.customerBonusSettlements = [
                        action.payload,
                        ...(state.bonusSettlementSupplierDetail.customerBonusSettlements || []),
                    ];
                }
                state.requesting = false;
            })
            .addCase(updateSupplierBonusSettlementFiles.fulfilled, (state, action) => {
                if (state.bonusSettlementSupplierDetail) {
                    state.bonusSettlementSupplierDetail.documents = [
                        ...(state.bonusSettlementSupplierDetail.documents ?? []).filter(
                            document => !action.payload.deletedFileIds.includes(document.id)
                        ),
                        ...action.payload.uploaded,
                    ];
                }
            })
            .addCase(removeCustomer.fulfilled, (state, action) => {
                if (state.bonusSettlementSupplierDetail) {
                    state.bonusSettlementSupplierDetail.customerBonusSettlements =
                        state.bonusSettlementSupplierDetail.customerBonusSettlements?.filter(
                            customer => customer.id !== action.payload
                        ) || [];
                }
            })
);
